// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.phoneverification.RentalManagerUserPhoneVerificationV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  PhoneVerificationSendVerificationCodeRequestDto,
  PhoneVerificationSendVerificationCodeV2Dto,
  PhoneVerificationValidateVerificationCodeRequestDto,
  PhoneVerificationValidateVerificationCodeV2Dto,
} from '../..';

export const RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode_Path =
  '/api/web/v2/users/phoneVerification/sendVerificationCode';

/**
 * Send a verification code to the provided phone
 */
export const RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode = (
  postData: PhoneVerificationSendVerificationCodeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    PhoneVerificationSendVerificationCodeRequestDto,
    PhoneVerificationSendVerificationCodeV2Dto
  >(
    {
      endpoint: RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode_Path =
  '/api/web/v2/users/phoneVerification/validateVerificationCode';

/**
 * Determine if the verification code is valid for the phone being verified
 */
export const RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode = (
  postData: PhoneVerificationValidateVerificationCodeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    PhoneVerificationValidateVerificationCodeRequestDto,
    PhoneVerificationValidateVerificationCodeV2Dto
  >(
    {
      endpoint: RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
